/** Payload persisted on transaction at buy-now / cart / stripe-checkout. */
export type CheckoutShippingPayload = {
  shipping_provider?: string
  shipping_dest_city?: string
  shipping_dest_postal?: string
  shipping_locker_id?: string
  shipping_locker_name?: string
  buyer_address_id?: number
  shipping_eur_override?: number
}

export function buildCheckoutShippingPayload(input: {
  provider?: string | null
  destCity?: string | null
  destPostal?: string | null
  lockerId?: string | null
  lockerName?: string | null
  buyerAddressId?: number | null
  shippingEur?: number | null
}): CheckoutShippingPayload {
  const out: CheckoutShippingPayload = {}
  if (input.provider) out.shipping_provider = input.provider
  if (input.destCity) out.shipping_dest_city = input.destCity
  if (input.destPostal) out.shipping_dest_postal = input.destPostal
  if (input.lockerId) out.shipping_locker_id = input.lockerId
  if (input.lockerName) out.shipping_locker_name = input.lockerName
  if (input.buyerAddressId != null) out.buyer_address_id = input.buyerAddressId
  if (input.shippingEur != null && input.shippingEur >= 0) {
    out.shipping_eur_override = input.shippingEur
  }
  return out
}
